/**
 * Created by claude on 09.02.26.
 */

class MainSceneComponent extends ScriptComponent {
    onCreate() {
        this.preloadBundles = this.options.preloadBundles || ["starter_pack", "tile_shop"];
    }

    onSceneLoaded(options) {
        options = options || {};

        if (typeof FlyingAdView !== "undefined") {
            this.node.addChild(new FlyingAdView());
        }

        cleverapps.environment.setLevel(options.levelNo !== undefined ? options.levelNo : levels.user.currentPhysicalLevel.level);
        cleverapps.environment.setEpisode(options.episodeNo !== undefined ? options.episodeNo : levels.user.currentPhysicalLevel.episode);

        cleverapps.placements.run(Placements.INTERMEDIATE);

        cleverapps.bundleLoader.preloadBundles(this.preloadBundles);

        this.addMiniPromo();
    }

    addMiniPromo() {
        if (!cleverapps.miniPromo || !cleverapps.miniPromo.needShow()) {
            return;
        }

        cleverapps.miniPromo.show(this.node);
    }

    onCloseAction() {
        if (connector.platform.hasCloseApplication()) {
            cleverapps.focusManager.display({
                focus: "ConfirmExitWindow",
                action: function (f) {
                    new ConfirmExitWindow({
                        action: function () {
                            connector.platform.closeApplication();
                        }
                    });

                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
            return true;
        }

        return false;
    }
}

Prefab.registerComponent("MainSceneComponent", MainSceneComponent);
